export const ProductOrderStatus = {
  Pending: 0,
  Paid: 1,
  Cancelled: 2,
};

export const ProductOrderStatusNames = {
  0: 'Beklemede',
  1: 'Ödendi',
  2: 'İptal Edildi',
};

export const ProductPaymentMethodNames = {
  0: 'Nakit',
  1: 'Banka Havalesi/EFT',
  2: 'Kredi Kartı',
  3: 'Online Ödeme',
};

export const LOW_STOCK_THRESHOLD = 5;

export const getProductOrderStatusChipSx = (status) => {
  switch (status) {
    case ProductOrderStatus.Paid:
      return { backgroundColor: '#DFFFEA', color: '#17C653' };
    case ProductOrderStatus.Cancelled:
      return { backgroundColor: '#F5F5F5', color: '#666666' };
    default:
      return { backgroundColor: '#E7EDF4', color: '#0E4D94' };
  }
};
